import React from 'react';
import './IntroSection.scss';

const IntroSection = () => {
  return (
    <div className='intro-section-container' id='home'>
      <div className='intro-content'>
        <h1 className='intro-title'>Gurpreet Dental & Implant Centre</h1>
        <p className='intro-subtitle'>Spreading Smiles Since 1995</p>
      </div>
    </div>
  )
}

export default IntroSection;